import angular from 'angular';

export default angular
  .module('csm.books.NSFChecksConfig', [])
  .provider('NSFChecksConfig', NsfChecksConfigProvider).name;

/* @ngInject */ function NsfChecksConfigProvider() {
  this.templateIDs = {
    Main: 'main.template.html',
    ReturnItems: 'returnItems.template.html'
  };

  this.$get = [
    '$templateCache',
    function ($templateCache) {
      $templateCache.put('main.template.html', '<nsf-check>');
      $templateCache.put(
        'returnItems.template.html',
        '<return-items return-route="$resolve.returnRoute" ledger-item-ids="$resolve.ledgerItemIDs">'
      );
    }
  ];

  this.buildRoutes = function () {
    return {
      when: {
        /*---------------------------------*/
        /* Main route for the application. */
        /*---------------------------------*/
        main: {
          path: '/',
          params: { templateUrl: this.templateIDs.Main, resolve: {} }
        },

        /*------------------------------------------------------*/
        /* Return Items component from the Returns application. */
        /*------------------------------------------------------*/
        returnItems: {
          path: '/returnItems/:id',
          params: {
            templateUrl: this.templateIDs.ReturnItems,

            /*---------------------------------------------------*/
            /* Ensures that we are arriving at the returns route */
            /* from the NSF Check, and not from a reload, as the */
            /* data will no longer be available on a reload.     */
            /*---------------------------------------------------*/
            resolve: function () {
              return {
                returnRoute: function ($q, Data) {
                  return Data.nsfCheck ? '/' : $q.reject('root');
                },
                ledgerItemIDs: function ($q, Data) {
                  if (Data.nsfCheck)
                    return Data.nsfCheck.checkPayment.reversals;
                }
              };
            }
          }
        }
      },

      otherwise: { redirectTo: '/' }
    };
  };

  /*****************************************************************************
   * configRoutes */
  /**
   * Configures the $routeProvider.
   *
   * @param  $routeProvider  Route Provider from the configuration.
   *****************************************************************************/
  this.configureRoutes = function ($routeProvider) {
    var routes = this.buildRoutes();

    for (var route in routes.when) {
      var when = routes.when;
      $routeProvider.when(when[route].path, when[route].params);
    }
    $routeProvider.otherwise(routes.otherwise);
  };
}
